module.exports = __webpack_public_path__ + "static/RUmobSlide5-ed410b6bf0de994e521baa7e534c4525.jpg";